export enum DistributionMode {
    REP_12 = 'dispatchAnnualEntry12',
    REP_14 = 'dispatchAnnualEntry14',
    REP_WEIGHT = 'dispatchAnnualEntryWeight',
    REP_LAST_WEIGHT = 'dispatchAnnualEntryLastWeight',
}
